<template>
    <!-- new item form -->
    <div class="p-col-12 p-md-9 p-mx-auto box">
        <div class="p-text-right">
            <Button 
                label="Add New Silenced Word"
                @click="newItemForm.visible = !newItemForm.visible"
                class="p-button-outlined p-button-info p-button-text" />
        </div>

        <div class="p-fluid p-formgrid p-grid p-mt-2"
            v-if="newItemForm.visible">
            <div class="p-field p-col-6 p-md-4">
                <Dropdown class="p-text-left" placeholder="Select Source"
                    v-model="newItemForm.source" :options="newsSources"
                    optionLabel="name" optionValue="id"
                    style="width:100%" />
            </div>
            <div class="p-field p-col-12 p-md-8">
                <span class="p-float-label">
                    <InputText id="words" type="text" v-model="newItemForm.words" />
                    <label for="words">Silenced words</label>
                </span>
            </div>
            <div class="p-col-12 p-md-12">
                <div class="p-field">
                    <Button 
                        label="Add New Silenced Word"
                        @click="insertItem()"
                        :loading="newItemForm.loading"
                        class="p-button-outlined p-button-info p-button-text" />
                </div>
            </div>
        </div>
    </div>

    <!-- silenced words list -->
    <div class="p-grid p-mx-auto">
        <div class="p-col-12 p-md-9 p-mx-auto">
            <DataTable v-show="silencedWords.items?.length > 0" :paginator="false" :rowHover="true"
                    editMode="row" v-model:editingRows="editingRows" @row-edit-save="onRowEditSave"
                    :value="silencedWords.items" dataKey="id" responsiveLayout="scroll"
                    :loading="silencedWords.isLoading" >
                <Column field="id" header="#" sortable style="width:5%"></Column>
                <Column field="source" header="News Source" sortable style="width:20%">
                    <template #body="{data, field}">
                        {{ data[field] ?? 'Any source' }}
                    </template>
                    <template #editor="{data, field}">
                        <Dropdown placeholder="Select News Source"
                            v-model="data[field]" :options="newsSources" optionLabel="name" optionValue="id" />
                    </template>
                </Column>
                <Column field="enabled" sortable header="Enabled" style="width:5%">
                    <template #body="{data}">
                        <div class="p-text-center">
                            <Checkbox id="enabled"
                                v-model="data.enabled" :binary="true" :disabled="true" />
                        </div>
                    </template>
                    <template #editor="{data}">
                        <div class="p-text-center">
                            <Checkbox id="enabled"
                                v-model="data.enabled" :binary="true" :disabled="false" />
                        </div>    
                    </template>
                </Column>
                <Column field="words" header="Silenced Words" sortable style="width:50%">
                    <template #editor="{data, field}">
                        <InputText v-model="data[field]" placeholder="Silenced Words" class="p-col-12" id="words" type="text" />
                    </template>
                </Column>
                <Column :rowEditor="true" style="width:15%" class="p-text-right"></Column>
                <Column header="" style="width:5%" bodyStyle="">
                    <template #body="item">
                        <div style="">
                            <Button label="" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-plain"
                            @click="deleteItem(item.index, item.data.id)" />
                        </div>
                    </template>
                    <template #editor="{}"></template>
                </Column>
            </DataTable>
        </div>
    </div>
</template>

<script>
import Const, { NewsSources } from '../utils/const'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

import { isEmpty } from '../utils/utils'

export default {
    name: 'News Silenced Words',
    components: {
        Button, InputText, Dropdown, Checkbox, DataTable, Column
    },
    data() {
        return {
            newItemForm: {
                visible: false,
                loading: false
            },
            silencedWords: {
                isLoading: false,
                items: null
            },
            newsSources: NewsSources
                .filter(item => item.id !== Const.NewsSource.SLC),
            editingRows: [],
        }
    },
    emits: ["loginResult", "pageLoaded"],
    beforeMount() {
        var page = {
            title: 'News Silenced Words'
        }
        this.$emit('pageLoaded', page)
    },
    mounted() {
        this.newsSources.splice(0, 0, {id: null, name: 'Any source'})
        this.getSilencedWordsList()
    },
    methods: {
        async getSilencedWordsList() {
            let self = this,
                silencedWords = self.silencedWords,
                cookies = self.$cookies,
                toast = self.$toast,
                token = cookies.get('token')

            try {
                silencedWords.isLoading = true

                let response = await self.$http.get('api/news-silenced-words', {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                })

                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    silencedWords.items = response.data.items
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading new silenced words failed', detail:response.data.mesaj, life: 3000});
                }
            } catch(error) {
                console.log(error)
                toast.add({severity:'error', summary: 'Error', detail:error});
            } finally {
                silencedWords.isLoading = false
            }
        
        },
        async insertItem() {
            let self = this,
                newItemForm = self.newItemForm,
                silencedWords = self.silencedWords,
                toastMessage = null,
                cookies = self.$cookies,
                toast = self.$toast,
                token = cookies.get('token')
            
            if(isEmpty(newItemForm.words)) {
                toastMessage = 'Silenced words is empty!'
            }
            
            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }
            
            try {
                newItemForm.loading = true

                let response = await self.$http.post('api/news-silenced-words', newItemForm, {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                })

                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    silencedWords.items.push(response.data.item)

                    this.newItemForm = {
                        visible: true, enabled: true, loading: false
                    }
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Inserting new silenced words failed', detail:response.data.mesaj, life: 3000});
                }
            } catch(error) {
                console.log(error)
                toast.add({severity:'error', summary: 'Error', detail:error});
            } finally {
                newItemForm.loading = false
            }
        },
        async onRowEditSave(event) {
            let { newData, index } = event;
            let self = this,
                silencedWords = self.silencedWords,
                toastMessage = null,
                cookies = self.$cookies,
                toast = self.$toast,
                token = cookies.get('token')


            if(isEmpty(newData.words)) {
                toastMessage = 'Silenced words is empty!'
            }
            
            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            try {
                silencedWords.isLoading = true

                let response = await self.$http.put('api/news-silenced-words/'+newData.id, newData, {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                })

                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    silencedWords.items[index] = response.data.item
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Updating new silenced words failed', detail:response.data.mesaj, life: 3000});
                }
            } catch(error) {
                console.log(error)
                toast.add({severity:'error', summary: 'Error', detail:error});
            } finally {
                silencedWords.isLoading = false
            }
        },
        deleteItem(itemIndex, silencedWordId) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');

            this.$confirm.require({
                message: 'Are you sure you want to delete this silenced words permanently?',
                header: 'Delete',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Delete',
                rejectLabel: 'Cancel',
                accept: async () => {
                    try {
                        let response = await self.$http.delete('api/news-silenced-words/'+silencedWordId, {
                            headers: {
                                'authorization': 'Bearer ' + token
                            }
                        })

                        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                            cookies.set("token", response.headers['refresh-token']);

                            self.silencedWords.items.splice(itemIndex, 1)

                            toast.add({severity:'success', summary: 'Success', detail: 'Silenced words deleted successfully.', life: 1000});
                        } else {
                            console.log(response)
                            toast.add({severity:'warn', summary: 'Delete silenced words failed', detail:response.data.mesaj, life: 3000});
                        }
                    } catch(error) {
                        console.log(error)
                        toast.add({severity: 'error', summary: 'Error', detail: error});
                    }
                },
                reject: () => {
                }
            });

            console.log(silencedWordId)
        }
    }
}
</script>
